<mat-form-field fxLayout="column">
  <mat-chip-grid #chipList>
    <mat-chip-row [ngStyle]="{'font-size': 'small'}"
      *ngFor="let item of items"
      [selectable]="true"
      [removable]="true"
      (removed)="deleteConfirmItemDialog(item)">
      {{ getFieldsItemToDisplay(item) }}
      <mat-icon matChipRemove [matTooltip]="removeElementMessageTooltip">cancel</mat-icon>
    </mat-chip-row>

    <input matInput
           [disabled]="! canAddMoreElement()"
           type="text"
           name="searchInput"
           placeholder="{{searchPlaceHolder}}"
           matTooltip="{{toolTip}}"
           #searchInput
           [matChipInputFor]="chipList"
           [formControl]="ItemControl"
           [matAutocomplete]="auto"
           [(ngModel)]="searchTerm">

  </mat-chip-grid>

</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" fxLayout="column">
  <mat-option *ngFor="let item of itemSearch | async"
              (onSelectionChange)="addItem(item)">
    <span [matTooltip]="getFieldsItemToDisplay(item)">{{ getFieldsItemToDisplay(item) }}</span>
  </mat-option>
</mat-autocomplete>
